import moment from "moment";
import Api from "../services/api"

const fetchPlanWithPendingReviews = (planId, callback) => {
  const api = new Api();
  const payload = {
    params: {
      include_pending_reviews_only: true
    }
  }
  api.get(`/__api/v1/plan/${planId}`, payload)
  .then(response => {
    if (response.status !== 200) return;
    if (callback) callback(response.data);
  })
}

const markItemAsReviewed = (reviewId, callback) => {
  const api = new Api();
  api.put("/__api/v1/review/"+ reviewId + "/mark_as_reviewed")
  .then(response => {
    if (response.status !== 200) return;
    if (callback) callback(response.data);
  })
  .catch(err => console.log(err))
}


const formatPendingReviews = (pending_reviews) => {
  return pending_reviews.map((review) => {
    const { id, plan_id, reviewed, details: stringifiedDetails, created_at } = review;
    const details = JSON.parse(stringifiedDetails);
    const metadata = JSON.parse(details.metadata);
    const { work_phase_or_ambient_exposure, activity, hazard, unwanted_event, template_flags } = metadata;

    return {
      id,
      plan_id,
      reviewed,
      work_phase_or_ambient_exposure,
      activity,
      hazard,
      unwanted_event,
      template_flags,
      created_at: moment(created_at).format("DD MMM YYYY")
    }
  })

}

export { fetchPlanWithPendingReviews, formatPendingReviews, markItemAsReviewed }


// WEBPACK FOOTER //
// ./src/helpers/plan_helpers.js